import CommonButtonTemplate from "@/components/editors/template-blocks/cta-button/CommonButtonTemplate";
import { ImageButtonTemplate } from "@/states/page-editor/template-parts/image";
import { contentToHtml } from "@/utils/draft";

interface Props {
  part: ImageButtonTemplate;
  formPath?: string;
  confirmPath?: string;
}

export default function ImageButtonContent({
  part,
  formPath,
  confirmPath,
}: Props) {
  if (!part.content) {
    return <></>;
  }

  return (
    <div className="flex flex-col gap-6 justify-center content-center items-center w-full h-full leading-normal text-center">
      {part.content.block1 && (
        <div className="inline-block w-full">
          <div
            dangerouslySetInnerHTML={{
              __html: contentToHtml(part.content.block1.content),
            }}
            className="max-w-full min-h-[2rem] font-bold text-white"
            style={part.content.block1.textBaseStyle}
          ></div>
        </div>
      )}
      {part.content.block2 && (
        <div className="inline-block w-full">
          <div
            dangerouslySetInnerHTML={{
              __html: contentToHtml(part.content.block2.content),
            }}
            className="max-w-full min-h-[2rem] font-bold text-white"
            style={part.content.block2.textBaseStyle}
          ></div>
        </div>
      )}
      {part.content.block3 && (
        <div className="inline-block">
          <CommonButtonTemplate
            buttonContent={part.content.block3}
            formPath={formPath}
            confirmPath={confirmPath}
          />
        </div>
      )}
      {part.content.block4 && (
        <div className="inline-block w-full">
          <div
            dangerouslySetInnerHTML={{
              __html: contentToHtml(part.content.block4.content),
            }}
            className="max-w-full min-h-[2rem] font-bold text-white"
            style={part.content.block4.textBaseStyle}
          ></div>
        </div>
      )}
    </div>
  );
}
